import React, { FC, useState } from "react";
import { Card, CardContent, CardHeader, Container, Divider, Grid, Paper, Typography, InputAdornment, IconButton, MenuItem, TextField as MuiTextField } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import store from "./store";
import { observer } from "mobx-react";
import CustomTextField from "components/TextField";
import CustomCheckbox from "components/Checkbox";
import PhoneInputWithCountry from "components/PhoneField";
import InfoIcon from "@mui/icons-material/Info";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import MtmLookup from "components/mtmLookup";

type user_accountTableProps = {
  children?: React.ReactNode;
  isPopup?: boolean;
};

const User_accountAddEditBaseView: FC<user_accountTableProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleClickShowPasswordConfirm = () => setShowPasswordConfirm(!showPasswordConfirm);

  return (
    <Container maxWidth={props.isPopup ? false : 'xl'} sx={{ mt: props.isPopup ? 0 : 3, px: props.isPopup ? 0 : undefined, height: props.isPopup ? '100%' : 'auto' }}>
      <Grid container spacing={3} sx={{ height: props.isPopup ? '100%' : 'auto' }}>
        <Grid item md={12} xs={12} sx={{ height: props.isPopup ? '100%' : 'auto', display: props.isPopup ? 'flex' : 'block', flexDirection: props.isPopup ? 'column' : undefined }}>
          <form data-testid="user_accountForm" id="user_accountForm" autoComplete='off' style={{ height: props.isPopup ? '100%' : 'auto', display: props.isPopup ? 'flex' : 'block', flexDirection: props.isPopup ? 'column' : undefined }}>
            <Card component={Paper} elevation={props.isPopup ? 0 : 5} sx={{ height: props.isPopup ? '100%' : 'auto', display: props.isPopup ? 'flex' : 'block', flexDirection: props.isPopup ? 'column' : undefined }}>
              {!props.isPopup && (
                <>
                  <CardHeader title={
                    <span id="user_account_TitleName">
                      {translate('label:user_accountAddEditView.entityTitle')}
                    </span>
                  } />
                  <Divider />
                </>
              )}
              <CardContent sx={{ flex: props.isPopup ? 1 : undefined, overflow: props.isPopup ? 'auto' : undefined }}>
                <Grid container spacing={3}>

                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      value={store.username}
                      onChange={(event) => store.handleChange(event)}
                      name="username"
                      data-testid="id_f_user_account_username"
                      id='id_f_user_account_username'
                      label={translate('label:user_accountAddEditView.username')}
                      helperText={store.errors.username}
                      error={!!store.errors.username}
                      disabled={store.id !== 0}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      value={store.email}
                      onChange={(event) => store.handleChange(event)}
                      name="email"
                      data-testid="id_f_user_account_email"
                      id='id_f_user_account_email'
                      label={translate('label:user_accountAddEditView.email')}
                      helperText={store.errors.email}
                      error={!!store.errors.email}
                      type="email"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      value={store.full_name}
                      onChange={(event) => store.handleChange(event)}
                      name="full_name"
                      data-testid="id_f_user_account_full_name"
                      id='id_f_user_account_full_name'
                      label={translate('label:user_accountAddEditView.full_name')}
                      helperText={store.errors.full_name}
                      error={!!store.errors.full_name}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <CustomTextField
                      value={store.position}
                      onChange={(event) => store.handleChange(event)}
                      name="position"
                      data-testid="id_f_user_account_position"
                      id='id_f_user_account_position'
                      label={translate('label:user_accountAddEditView.position')}
                      helperText={store.errors.position}
                      error={!!store.errors.position}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <MuiTextField
                      select
                      fullWidth
                      size="small"
                      value={store.department_id ?? ""}
                      onChange={(e) => {
                        const val = e.target.value;
                        store.department_id = val === "" ? null : Number(val);
                      }}
                      label="Отдел"
                      id='id_f_user_account_department_id'
                    >
                      <MenuItem value=""><em>— Не выбрано —</em></MenuItem>
                      {store.Departments.map((d: any) => (
                        <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>
                      ))}
                    </MuiTextField>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <PhoneInputWithCountry
                      value={store.phone}
                      onChange={(value, country) => store.handlePhoneChange(value, country)}
                      id='id_f_user_account_phone'
                      label={translate('label:user_accountAddEditView.phone')}
                      error={!!store.errors.phone}
                      helperText={store.errors.phone}
                      defaultCountryId="kg"
                    />
                  </Grid>

                  <Grid item md={3} xs={6}>
                    <CustomCheckbox
                      value={store.is_active}
                      onChange={(event) => store.handleChange(event)}
                      name="is_active"
                      label={translate('label:user_accountAddEditView.is_active')}
                      id='id_f_user_account_is_active'
                    />
                  </Grid>
                  <Grid item md={3} xs={6}>
                    <CustomCheckbox
                      value={store.has_signing_rights}
                      onChange={(event) => store.handleChange(event)}
                      name="has_signing_rights"
                      label={translate('label:user_accountAddEditView.has_signing_rights')}
                      id='id_f_user_account_has_signing_rights'
                    />
                  </Grid>
                    <Grid item md={6} xs={12}>
                        <MtmLookup
                            value={store.id_roles}
                            onChange={(name, value) => store.changeRoles(value)}
                            name="roles"
                            data={store.Roles}
                            label={translate("label:user_accountAddEditView.id_roles")}
                        />
                    </Grid>
                  {store.last_login && (
                    <Grid item md={12} xs={12}>
                      <Stack direction="row" alignItems="center" gap={1}>
                        <InfoIcon color="info" />
                        <Typography variant="body2" color="text.secondary">
                          {translate('label:user_accountAddEditView.last_login')}: {new Date(store.last_login).toLocaleString()}
                        </Typography>
                      </Stack>
                    </Grid>
                  )}

                </Grid>
              </CardContent>
            </Card>
          </form>
        </Grid>
        {props.children}
      </Grid>
    </Container>
  );
});

export default User_accountAddEditBaseView;